"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _IconBase = require("../IconBase");

var _utils = require("../utils");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

var iconBase = {
  width: 10,
  height: 14
};

var CaretLeft = /*#__PURE__*/function (_PureComponent) {
  _inheritsLoose(CaretLeft, _PureComponent);

  function CaretLeft() {
    return _PureComponent.apply(this, arguments) || this;
  }

  var _proto = CaretLeft.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        color = _this$props.color,
        size = _this$props.size,
        block = _this$props.block;
    var newSize = (0, _utils.calcIconSize)(iconBase, size);
    return _react2.default.createElement(_IconBase.Svg, {
      name: "caret-left",
      size: newSize,
      block: block,
      viewBox: "0 0 10 14"
    }, _react2.default.createElement("path", {
      d: "M7.72356 8.48154C7.32958 8.89452 6.67042 8.89452 6.27644 8.48154L0 1.90235L1.81481 0L7 5.43529L12.1852 0L14 1.90235L7.72356 8.48154Z",
      transform: "translate(9.23999) rotate(90)",
      fill: color
    }));
  };

  return CaretLeft;
}(_react.PureComponent);

CaretLeft.defaultProps = {
  color: 'currentColor',
  size: 16,
  block: false
};
CaretLeft.propTypes = {
  color: _propTypes2.default.string,
  size: _propTypes2.default.number,
  block: _propTypes2.default.bool
};
exports.default = CaretLeft;